import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { NavbarComponent } from '../../components/Navbar/Navbar.component';
// import Header from "../../components/Header";
import { SidebarComponent } from '../../components/Sidebar/Sidebar.component';
import FreshdeskWebChat from '../../components/FreshdeskWebChat';
import { SetupGuideProvider } from '../../contexts/SetupGuide.context';
import { NavbarSlotProvider } from '../../contexts/NavbarSlot.context';
import { TourProvider } from '../../contexts/Tour.context';
import { TourTooltip, TourNavigator } from '../../components/Tour';
import { SetupGuide } from '../../components/SetupGuide/SetupGuide.component';
import {
  SupportWidgetProvider,
  useSupportWidgetHidden,
} from '../../contexts/SupportWidget.context';
import AppLogo from '@/assets/img/brand/logo-transparent-blue.png';
import { appRoutes } from '@/routes';

const MainContent = ({ location, children }) => {
  // const hasNavbar = location && location.pathname.includes('dashboard') ? true : false
  const hasNavbar = true;
  const [bannerVisible, setBannerVisible] = useState(false);
  const supportWidgetHidden = useSupportWidgetHidden();

  // Check if banner should be visible
  useEffect(() => {
    const checkBannerVisibility = () => {
      const bannerElement = document.querySelector(
        '.subscription-warning-banner'
      );
      const isVisible =
        bannerElement &&
        bannerElement.style.display !== 'none' &&
        bannerElement.offsetParent !== null;

      console.log('Subscription: Main Layout - Banner visibility:', {
        bannerElement: !!bannerElement,
        display: bannerElement?.style.display,
        offsetParent: !!bannerElement?.offsetParent,
        isVisible,
        paddingTop: isVisible ? '60px' : '0px',
      });

      setBannerVisible(isVisible);
    };

    // Check immediately
    checkBannerVisibility();

    // Set up observer to watch for banner changes
    const observer = new MutationObserver(checkBannerVisibility);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });

    return () => observer.disconnect();
  }, []);
  return (
    <TourProvider>
      <SetupGuideProvider>
        <NavbarSlotProvider>
          <TourNavigator />
          {!supportWidgetHidden && <FreshdeskWebChat />}
          <SidebarComponent
            location={location}
            logo={{
              innerLink: appRoutes().teamDashboard,
              imgSrc: AppLogo,
              imgAlt: '...',
            }}
          />
          <div
            className="main-content"
            id="main_portal_target"
            style={{
              transition: 'margin-left 0.3s ease',
              backgroundColor: '#f9fafb',
            }}
          >
            {/* Padding lives here, not on the outer .main-content box, so the
                banner's push-down never grows this element past its parent's
                fixed 100vh (border-box sizing) — that mismatch is what let
                .main-content's overflow:hidden permanently clip the bottom of
                this element's own scrollable content. */}
            <div
              className="main-content-child with-scroll"
              style={{
                paddingTop: bannerVisible ? '60px' : '0px',
                transition: 'padding-top 0.3s ease',
              }}
            >
              {hasNavbar && <NavbarComponent location={location} />}

              <div className="content">{children} </div>
            </div>
          </div>
          <SetupGuide />
          <TourTooltip />
        </NavbarSlotProvider>
      </SetupGuideProvider>
    </TourProvider>
  );
};

MainContent.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

const Main = (props) => (
  <SupportWidgetProvider>
    <MainContent {...props} />
  </SupportWidgetProvider>
);

Main.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(Main);
